<template>
  <div
      class="drop-zone"
      @drop="onDrop($event)"
      @dragover.prevent
      @dragenter.prevent
  >
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        @update:options="updateOptions"
        :server-items-length="totalRecords"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [10, 15, 20, 50, 100]
        }"
        :height="windowHeight"
        fixed-header
        ref="left_table"
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
          <v-radio-group
              dark
              v-model="batch_run_filter"
              row
              class="ml-5 mt-4"
              @change="onUpdateSearchTerm"
          >
            <v-radio
                dark
                label=""
                value="unscheduled"
                color="unscheduled"
            ></v-radio>
            <v-radio
                dark
                label=""
                value="warning"
                on-icon="mdi-alert-box"
                off-icon="mdi-alert-box-outline"
                color="flamingo"
            ></v-radio>
            <v-radio
                dark
                label=""
                value="scheduled"
                on-icon="mdi-clock-time-eight"
                off-icon="mdi-clock-time-eight-outline"
                color="scheduled"
            ></v-radio>
            <v-radio
                dark
                label=""
                value="late"
                on-icon="mdi-clock-alert"
                off-icon="mdi-clock-alert-outline"
                color="flamingo"
            ></v-radio>
          </v-radio-group>
        </v-toolbar>
      </template>
      <template v-slot:item.notion_id="{ item }">
        <v-row>
          <v-icon
              v-if="item.notion_id != null"
              color="primary"
              size="20"
              @click="onNotion(item)"
          >
            mdi-alpha-n-box-outline
          </v-icon>
        </v-row>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row>
          <BatchRunBadge
              :item="item"
              :draggable="true"
          />
        </v-row>
      </template>
      <template v-slot:item.warning="{ item}">
        <BatchRunWarning :warning="item.warning"/>
      </template>
      <template v-slot:item.smd_end="{ item }">
        <span v-if="item.smd_end != null">
          {{ item.smd_end | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:item.tht_end="{ item }">
        <span v-if="item.tht_end != null">
          {{ item.tht_end | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:item.delivery_date="{ item }">
        <span v-if="item.delivery_date != null">
          {{ item.delivery_date | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:item.lt_mat="{ item }">
        <span v-if="item.lt_mat != null">
          {{ item.lt_mat | moment("DD.MM.YYYY") }}
        </span>
      </template>
      <template v-slot:item.lt_min="{ item }">
        <span v-if="item.lt_min != null">
          {{ item.lt_min | moment("DD.MM.YYYY") }}
        </span>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import BaseDeleteDialog from "@/components/BaseDeleteDialog";
import BaseTaskProgress from "@/components/BaseTaskProgress"
import BaseModal from "@/components/Base/BaseModal";
import BatchRunBadge from "@/components/BatchRun/BatchRunBadge"
import BatchRunWarning from "@/components/BatchRun/BatchRunWarning"

export default {
  name: 'BatchRunList',
  props: {
    'subheight': {type: [Number], default: 200},
  },

  components: {
    BaseDeleteDialog,
    BaseTaskProgress,
    BaseModal,
    BatchRunBadge,
    BatchRunWarning,
  },

  computed: {
    ...mapGetters('BatchRun', ['getColumns']),
    ...mapFields('BatchRun', ['options', 'totalRecords', 'options.page', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'filters']),
    ...mapFields('BatchRunWeek', {
        searchTermWeek: 'searchTerm',
        filtersWeek: 'filters',
      }),
  },

  methods: {
    ...mapActions('BatchRun', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems']),
    ...mapActions('BatchRunWeek', {
      fetchActionItem: 'fetchActionItem',
      fetchItemListWeek: 'fetchItemList',

    }),
    onResize() {
      this.windowHeight = (window.innerHeight - this.subheight) + 'px'
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.briefView = this.batch_run_filter != "late";
      this.filters['delivery_date'] = this.batch_run_filter
      this.filtersWeek['delivery_date'] = this.batch_run_filter
      this.searchTermWeek = this.searchTerm
      this.fetchItemList()
      this.fetchItemListWeek()
    }, 800),

    updateOptions() {
      // console.log('updateOptions', this.filters)
      this.filters['delivery_date'] = this.batch_run_filter
      this.fetchItemList()
    },

    onSyncNotion() {
      // console.log('onSyncNotion')
      this.fetchSyncNotionSelectedItems();
    },
    onRestore() {
      // console.log('onRestore')
      this.fetchRestoreSelectedItems();
    },
    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },
    getItemColor(item) {
      if (item.smd > 0 && item.tht > 0)
        return 'purple'
      if (item.tht > 0)
        return 'blue'
      return 'orange'
    },
    onStartDrag(event, item) {
      // console.log('onStartDrag', event, item)
      event.dataTransfer.setData('itemID', item.id)
    },
    onDrop(event) {
      if (this.batch_run_filter === 'unscheduled') {
        // console.log('onDrop', event)
        let item_id = event.dataTransfer.getData('itemID')
        this.fetchActionItem({
          action_name: 'clear_batch_run_delivery_date',
          id_list: [item_id],
        })
      }
    },
    onNotion(item) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  }
  ,

  async mounted() {
    // console.log('mounted')
    window.addEventListener("resize", this.onResize);
  }
  ,

  created() {
    window.addEventListener("resize", this.onResize);
  }
  ,
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  }
  ,

  data() {
    return {
      hover: false,
      windowHeight: (window.innerHeight - this.subheight) + 'px',
      batch_run_filter: 'unscheduled',
    }
  }
}
</script>

<style scoped lang="scss">
</style>
